import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

interface InputBoxPhoneProps {
  label: string;
  name: string;
  value: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errorFeedback?: string;
  onChange?: any;
  onBlur?: any;
  setFieldValue: any;
  isValid?: boolean;
  isInvalid?: boolean;
  disabled?: boolean;
}

const maskPhoneNumber = (value: string) => {
  const onlyNums = value.replace(/\D/g, '');
  if (onlyNums.length <= 3) {
    return `(${onlyNums}`;
  }
  if (onlyNums.length <= 6) {
    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}`;
  }
  return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const InputBoxPhoneMui: React.FC<InputBoxPhoneProps> = ({
  label,
  name,
  type = 'text',
  placeholder,
  required = false,
  value,
  errorFeedback,
  onChange,
  setFieldValue,
  onBlur,
  isValid,
  isInvalid,
  disabled = false,
}) => {
  React.useEffect(() => {
    setFieldValue(name, value);
  }, [value, setFieldValue, name]);

  return (
    <TextField
      fullWidth
      label={label}
      name={name}
      type={type}
      placeholder={placeholder || '(xxx) xxx-xxxx'}
      required={required}
      value={value}
      onChange={(e) => {
        const maskedValue = maskPhoneNumber(e.target.value);
        setFieldValue(name, maskedValue);
      }}
      onBlur={onBlur}
      error={isInvalid}
      helperText={isInvalid ? errorFeedback : ''}
      disabled={disabled}
      slotProps={{
        input: {
          startAdornment: <InputAdornment position="start">+1</InputAdornment>,
        },
      }}
      sx={{
        '& .MuiInputAdornment-root': {
          marginRight: 1,
        },
      }}
    />
  );
};
